module.exports = __webpack_public_path__ + "static/media/large-screen01.e8ec3840.png";